<style scoped>
.loginbg1 {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.loginbg2 {
  width: 800px;
  display: flex;
  height: 1000px;
  align-items: center;
  flex-direction: column;
}
.loginbg3 {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #ffffff;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
<template>
  <div class="loginbg1">
    <div class="loginbg2" v-bgImg="pic_3">
      <div v-show="!logined" class="loginbg2" v-bgImg="pic4">
        <div style="font-size: 25px;margin-top: 30px;width:778px;height:76px" v-bgImg="pic_2"></div>
        <div style="font-size: 25px;margin-top: 40px;width:214px;height:56px" v-bgImg="pic_1"></div>
        <div style="font-size: 40px;margin-top: 80px;letter-spacing:2px">广东伟仕达电器科技有限公司</div>
        <div style="font-size: 40px;margin-top: 40px;letter-spacing:2px">达人签约系统</div>
        <div class="loginbg3">
          <div class="border-color-light" style="margin-top: 50px;">
            <el-input
              placeholder="请输入手机号"
              v-model="userphone"
              style="height:80px;width: 240px;  outline:none;line-height:80px;color:rgb(255, 255, 255);border: none;padding-left: 20px;font-size: 16px"
            ></el-input>
          </div>
          <el-button
            size="mini"
            @click="getsms"
            type="primary"
            style="height:80px;width: 120px;margin-top: 50px;margin-left: 20px;color:rgb(255, 255, 255);font-size:18px; text-align:center;"
          >获取验证码</el-button>
        </div>
        <div class="border-color-light" style="margin-top: 30px;">
          <el-input
            placeholder="请输入验证码"
            v-model="sms"
            style="height:80px;  outline:none;width: 380px;line-height:80px;color:rgb(255, 255, 255);border: none;padding-left: 20px;font-size: 16px"
          ></el-input>
        </div>
        <div class="loginbg3">
          <el-button
            size="mini"
            type="primary"
            style="height:60px;width: 160px;margin-top: 30px;color:rgb(255, 255, 255);font-size:22px; text-align:center;"
            @click="loginhetong()"
          >登录</el-button>
        </div>
      </div>
      <div v-show="logined" class="loginbg2" v-bgImg="pic4">
        <div style="font-size: 25px;margin-top: 30px;width:778px;height:76px" v-bgImg="pic_2"></div>
        <el-button
          size="mini"
          type="primary"
          style="height:60px;width: 160px;margin-top: 230px;color:rgb(255, 255, 255);font-size:22px; text-align:center;"
          @click=" changepage('types') "
        >合同签约</el-button>
        <el-button
          size="mini"
          type="primary"
          style="height:60px;width: 160px;margin-top: 130px;color:rgb(255, 255, 255);font-size:22px; text-align:center;"
          @click=" changepage('mycontract') "
        >我的合同</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'login',
  components: {},
  data() {
    return {
      user: '',
      password: '',
      pic_1: this.utils.getQiniuWidthUrl('FiZ9o4WkkEXF7Dw1cmab7y7OMOM4^logo.png^6977.png', 214, 2, 'png'),
      pic_2: this.utils.getQiniuWidthUrl('FicyKI2f_9Yo2L8C-5l7qsbTm7VJ^合同头标.png^10610.png', 778, 2, 'png'),
      pic_3: this.utils.getQiniuWidthUrl('Filt7-f1xAhUPHj-lBW-ZBMJ_hKH^合同背景.png^761526.png', 800, 2, 'png'),
      pic_4: this.utils.getQiniuWidthUrl('FiNyoE0HIftPfqDXsWtIBNQvEi6H^水印.png^48231.png', 800, 2, 'png'),
      sms: '',
      userphone: '',
      logined: false,
    }
  },
  created() {
    if (this.utils.isUserLogin()) {
      this.logined = true
      return
    }
  },
  methods: {
    getphone() {
      this.$emit('getphone', this.user)
    },
    changepage(type) {
      this.$emit('changepage', type)

    },
    loginhetong() {

      let param = {
        user_phone: this.userphone,
        user_phone_code: '86',
        sms_type: 'login',
        sms_code: this.sms,
      }

      this.req.post(url_api_common_userAccount_preprocess, this.qs.stringify(param)).then((result) => {
        this.utils.setCookie("user_session", result.user_info.user_session, "1y", "/")
        console.log(this.utils.getCookie("user_session"))
        this.logined = true
        vue_cookies.set('piclink', value, "1y", "/");
        this.utils.successMessage(result.info)
      }).catch((error) => {
        //    alert(error)
      });
    },
    getsms() {
      let param = {
        sms_type: 'login',
        user_phone: this.userphone,
        user_phone_code: '86'
      }

      this.req.post(url_api_admin_native_userAccount_getSms, this.qs.stringify(param)).then((result) => {
        this.utils.successMessage(result.info)

      }).catch((error) => {
        //    alert(error)
      });
    },
  }

}
</script>